import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentHandler } from '../uicomponent';
import * as React from 'react';
import { Strings } from '../../../utils/resources/strings';
import { ToolbarSearchComponentProps, ToolbarSearchComponentHandler, ToolbarSearchComponentState } from './toolbarsearchcomponent';
import { ToolbarSearchCSSStyle } from './toolbarsearchcss';
import { BaseContext } from '../../../utils/basecontext';
import { DropDownRowViewModelImpl, DropdownRowViewModelHandler } from '../dropdownlist/dropdownrow/dropdownviewmodel';
import { DropDownListComponent } from '../dropdownlist/dropdownlistcomponent';
import { DropDownDtoImpl, DropDownDto } from '../../../core/dto/dropdown/dropdowndto';
import { RoutingFeatures } from '../../components/navigation/routingfeature';
import { DropDownListCSSStyleImpl } from '../dropdownlist/dropdownlistcss';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { CategoriesCardComponent } from '../../components/home/categories/viewmodel/categoriescard/categoriescardcomponent';
import { LoaderWrapperComponent } from '../../components/popup/loaderwrappercomponent';
import { LoaderComponent } from '../loader/loadercomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';


export class ToolbarSearchViewImpl extends UIComponentViewImpl<UIDataModel> implements DropdownRowViewModelHandler
{
    private listViewModel: DropDownRowViewModelImpl;
    private loaderWrapperComponent:LoaderWrapperComponent;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        
       this.listViewModel = new DropDownRowViewModelImpl(true, context, this);
    }

    bindHandlers()
    {
        this.onSignIn = this.onSignIn.bind(this);
        this.showMyAccountOption = this.showMyAccountOption.bind(this);
        this.hideMyAccountOption = this.hideMyAccountOption.bind(this);
        this.showTunesOption = this.showTunesOption.bind(this);
        this.hideTunesOption = this.hideTunesOption.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.onDoItYouselfClicked = this.onDoItYouselfClicked.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this);
        this.onHovered = this.onHovered.bind(this);
        this.onHoveredExit = this.onHoveredExit.bind(this);
    }

    draw(props: ToolbarSearchComponentProps, state: ToolbarSearchComponentState, cssStyle: ToolbarSearchCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        if(state.isMyAccountSelected)
        {
            this.listViewModel.setListDatas(this.getListOfDropDown());
        }
       return (
           <>
             <div style={cssStyle.getToolbarContainerCSSStyle()}>
                   
                    {/* <img onClick={this.onLogoClicked} src={props.context.getResources().getImage("mptlogo.svg")} style={cssStyle.getIconCSSStyle()} /> */}
                    {/* <img onClick={this.onLogoClicked} src={props.context.getResources().getImage("mpt_logo.svg")} style={cssStyle.getIconCSSStyle()} /> */}

                <div style={{display: "flex", flex: 1}}>
                    <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.showTunesOption}>
                        <label onMouseOver={this.onHovered} onMouseLeave={this.onHoveredExit} style={cssStyle.getTitleCSSStyle(state.isTunesSelected, state.isHovered)}>{props.context.getResources().getString(Strings.tunes)}</label>
                        <img  style={{width:'10px', cursor: "pointer",marginLeft:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?'7px':"0px",marginRight:this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH?"0px":"7px", height:'6px'}} src={this.getContext().getResources().getImage("down_arrow_gray.svg")}/>
                       
                    </div>
                    {/* <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.onSalathiClicked}>
                        <label style={cssStyle.getTitleCSSStyle()}>{props.context.getResources().getString(Strings.salati)}</label>
                    </div> */}
                    {/*<div style={cssStyle.getTitle2DivCSSStyle()} onClick={this.onDoItYouselfClicked}>
                        <label style={cssStyle.geDoItYouselfCSSStyle(state.isDoitYourselfSelected)}>{props.context.getResources().getString(Strings.doityourself)}</label>
                        <img  style={{width:'10px', cursor: "pointer",marginLeft:'7px',height:'6px'}} src={this.getContext().getResources().getImage("down_arrow_gray.svg")}/>
                </div>*/}
                </div>
                {/* <div style={cssStyle.getSearchDivCSSStyle()}>
                    <SearchBoxComponent searchKey={props.searchKey} onSearchBoxButtonClicked={this.onSearchButtonClicked} context={props.context}/>
                </div> */}
                    {/* {
                     !props.context.getUserContext().getIsLoggedIn() && 
                      <>
                        <label onClick={this.onSignIn} style={cssStyle.getSignUpCSSStyle()}>{props.context.getResources().getString(Strings.signin)}</label>
                        </>
                    } */}
                    {
                        props.context.getUserContext().getIsLoggedIn() && 
                        <>
                        <div style={cssStyle.getMyAccountDivCSSStyle()}>
                            <div  style={cssStyle.getProfileIconDivCSSStyle()} onClick={this.showMyAccountOption}>
                                <img src={this.getContext().getResources().getImage("profile.svg")}/>
                            </div>
                            <label style={cssStyle.getMyAccountTextCSSStyle()} onClick={this.showMyAccountOption}>{props.context.getResources().getString(Strings.myaccount)}</label>
                            {
                                state.isMyAccountSelected &&
                            <div onMouseLeave={this.hideMyAccountOption} style={cssStyle.getMyAccountDropDownSSStyle()}>
                                <DropDownListComponent cssStyle={new DropDownListCSSStyleImpl(this.getContext())} listViewModel={this.listViewModel} context={props.context}/>
                            </div>
                            }
                        </div>
                        </>
                    }
             </div>
             {
                 state.isTunesSelected &&
                <div onMouseLeave={this.hideTunesOption} style={cssStyle.getTunesDropDownSSStyle()}>
                {
                    state.categories.map((t: CategoryDto, position: number) =>
                    {
                        return <CategoriesCardComponent key={position} onSelected={this.onCategorySelected} context={this.getContext()} categoryDto={t}  position={position}/>;
                    })
                }
                </div>
             }
           <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
       );
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }

    onCategorySelected(categoryDto: CategoryDto): void
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onCategoriesSelected(categoryDto.getTitle());
    }

    onHovered()
    {
     
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onHovered(true);
    }
    onHoveredExit()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onHovered(false);
    }
    onRowSelected(dropDownDto: DropDownDto): void 
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onMyAccountOptionClicked(dropDownDto);
    }
    private onLogoClicked()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).deselectAll();
        (this.getUIProps() as ToolbarSearchComponentProps).onLogoClicked();
    }

    private onDoItYouselfClicked()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onDoItYourselfSelected(true);
        (this.getUIProps() as ToolbarSearchComponentProps).onDoItYourselfClicked();
    }

    // private onSalathiClicked()
    // {
    //     (this.getUIProps() as ToolbarSearchComponentProps).onSalathiClicked();
    // }

    private onSignIn()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onSignIn();
    }

    private showMyAccountOption() 
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onMyAccountSelected(true);
    }
    
    private hideMyAccountOption()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onMyAccountSelected(false);
    }

    private showTunesOption() 
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onTunesSelected(true);
    }
    
    private hideTunesOption()
    {
        (this.getUIComponentHandler() as ToolbarSearchComponentHandler).onTunesSelected(false);
    }

    private getListOfDropDown()
    {  let dropDown1 = new DropDownDtoImpl();
        dropDown1.setId(RoutingFeatures.PROFILE);
        dropDown1.setIconName("my_profile");
        dropDown1.setTitle(this.getContext().getResources().getString(Strings.myprofile));
       
        let dropDown2 = new DropDownDtoImpl();
        dropDown2.setId(RoutingFeatures.TRANSACTION_HISTORY);
        dropDown2.setIconName("history");
        dropDown2.setTitle(this.getContext().getResources().getString(Strings.history));

        let dropDown3 = new DropDownDtoImpl();
        dropDown3.setId(RoutingFeatures.WISHLIST);
        dropDown3.setIconName("settone");
        dropDown3.setTitle(this.getContext().getResources().getString(Strings.wishlist));

        let dropDown4 = new DropDownDtoImpl();
        dropDown4.setId(RoutingFeatures.MYTUNES);
        dropDown4.setIconName("my_tunes");
        dropDown4.setTitle(this.getContext().getResources().getString(Strings.mytunes));

        let dropDown5 = new DropDownDtoImpl();
        dropDown5.setId(RoutingFeatures.CALLER_GROUP);
        dropDown5.setIconName("caller_group");
        dropDown5.setTitle(this.getContext().getResources().getString(Strings.caller_group));

        let dropDown6 = new DropDownDtoImpl();
        dropDown6.setId(RoutingFeatures.BLACKLIST);
        dropDown6.setIconName("blacklist");
        dropDown6.setTitle(this.getContext().getResources().getString(Strings.blacklist));

       let dropDown7 = new DropDownDtoImpl();
       dropDown7.setId(RoutingFeatures.LOGOUT);
       dropDown7.setIconName("logout");
       dropDown7.setTitle(this.getContext().getResources().getString(Strings.logout));

        // return [dropDown1, dropDown2, dropDown3, dropDown4, dropDown5, dropDown6, dropDown7];
        return [dropDown1, dropDown2, dropDown3, dropDown4, dropDown7];
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbarwithsearch/toolbarsearchview.tsx